var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwesomeThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_awesome-thumbs-up",
    "data-name": "Icon awesome-thumbs-up",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-thumbs-up-2",
    "data-name": "Icon awesome-thumbs-up",
    d: "M3.25,7H.75A.75.75,0,0,0,0,7.75v7.5A.75.75,0,0,0,.75,16h2.5A.75.75,0,0,0,4,15.25V7.75A.75.75,0,0,0,3.25,7ZM2,14.75A.75.75,0,1,1,2.75,14,.75.75,0,0,1,2,14.75Zm10-12.2c0,1.326-.812,2.069-1.04,2.955h3.179A1.867,1.867,0,0,1,16,7.316a2.263,2.263,0,0,1-.607,1.537l0,0A2.61,2.61,0,0,1,15.1,11.34a2.471,2.471,0,0,1-.512,2.336,1.659,1.659,0,0,1-.192,1.395c-.638.916-2.219.929-3.555.929H10.75a8.971,8.971,0,0,1-3.736-.991A4.918,4.918,0,0,0,5.368,14.5.375.375,0,0,1,5,14.128V7.448a.375.375,0,0,1,.111-.266C6.349,5.958,6.881,4.663,7.9,3.647A3.785,3.785,0,0,0,8.69,1.806C8.829,1.228,9.119,0,9.75,0,10.5,0,12,.25,12,2.545Z",
    fill: "#455a64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwesomeThumbsUp);
export default __webpack_public_path__ + "static/media/awesome-thumbs-up.52d3dcec72150c7ab3acc8ea44870a3c.svg";
export { ForwardRef as ReactComponent };